import React, { useEffect, useState } from 'react';
import { Row, Col, Select, message, Spin, Divider, Input } from 'antd';
import FormInput from 'components/FormInput';
import Form, { FormInstance } from 'antd/lib/form';
import DF from 'DisplayFramework';
import ParListSelect from 'components/ParListSelect';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import { PricingResponse } from 'services/pricing';
import * as finEngine from 'services/finEngine';
import {
  FinConElementResponse,
  getFinContractById,
} from 'services/fincontract';
import { useQuery } from 'react-query';
import { getProposalById, PropThirdPartyResponse } from 'services/proposal';
import Title from 'components/Title';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import Bank from 'components/Bank/Bank';
import InputCurrency from 'components/InputCurrency';
export type TabContractChangeBKProps = {
  objectid: number;
  object: string;
  form?: FormInstance;
  data: Array<PropThirdPartyResponse>;
  setSuccessful?: any;
};

const TabContractChangeBK = ({
  data,
  objectid,
  object,
  form,
  setSuccessful,
}: TabContractChangeBKProps) => {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState({
    isLoading: false,
    isModSelected: false,
    newDuration: 0,
    effectDate: '',
    feesAmount: 0,
    feesFormula: '' as any,
    newElements: [] as FinConElementResponse[],
  });

  const { data: contract, isFetching } = useQuery(
    ['getFinContractById', { ctrid: objectid }],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data)
  );

  const { data: proposal, isLoading } = useQuery(
    ['getProposalById', { ctrid: objectid }],
    () => getProposalById({ ctrid: objectid }).then((res) => res.data),
    { enabled: !data }
  );

  useEffect(() => {
    const client = contract?.thirdParties.find(
      (e: any) => e.tprolecode === 'CLIENT' && e.status === 'ACTIVE'
    )?.bankAccountIn;
    if (contract) {
      form?.setFieldsValue({
        event: 'tabContractChangeBK',
        countcode: client?.countcode,
        bankname: client?.tpbankname,
        bic: client?.tpbic,
        bkey: client?.bkaccountkey,
        iban: client?.tpiban,
        branch: client?.bkbranchcode,
        bname: client?.bkcode,
        bnum: client?.bkaccountnum,
        btype: client?.bktype,
        tpid: client?.tpid,
        tprolecode: 'CLIENT',
      });
    }
    setSuccessful(isFetching && isLoading);
  }, [isFetching, isLoading]);

  const notInvoicedSchedule = contract?.conElements
    ?.find((e) => e.ctetype === 'FIN')
    ?.conElemSchedules.filter((s) => s.ciid === null);
  const offerid = contract?.offerid;

  const optionDates = notInvoicedSchedule?.map((e, index) => (
    <option key={index} value={e.ctsduedate.toString()}>
      {e.ctsduedate}
    </option>
  ));

  const calculateFees = (pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: contract?.conElements[0]?.conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: contract?.conElements[0]?.ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.conElements[0]?.ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse?.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse?.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse?.servduration ?? '',
          inServpercentage: pricing?.serviceResponse?.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: contract?.conElements[0]?.cteduration ?? 0,
          inInvestAmount: contract?.conElements[0]?.cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0]?.assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse?.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse?.servdurationdefault ?? 1,
          inStartDate: form?.getFieldValue('effectDate'),
          inServbasis: pricing?.serviceResponse?.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse?.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse?.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse?.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          form?.setFieldsValue({
            feesAmount: res.installmentamount,
            feesTax: (res.installmentamount * (pricing?.taxrate ?? 0)) / 100,
            feesTaxcode: pricing?.taxcode,
            feesTaxrate: pricing?.taxrate,
            feestype: pricing?.ctetype,
            feescategory: pricing?.ctecategory,
            feesFormula: pricing?.priid ?? ('' as any),
            tpid: contract?.tpidclient,
          });
        }
      });
  };

  return (
    <DF.Provider pagcode="TabTPBankAccount" entity={object} entityid={objectid}>
      <Spin spinning={isFetching || isLoading}>
        <Row gutter={16}>
          <FormInput col xs={6} name="affectDate">
            <Select
              defaultValue=""
              style={{ width: '100%' }}
              disabled={state.isModSelected}
            >
              {optionDates}
            </Select>
          </FormInput>
        </Row>

        <Divider orientation="left">
          {' '}
          <Title comcode="currentBankAccount" level={5} />
        </Divider>

        <Row gutter={16}>
          <Bank
            countcode={form?.getFieldValue('countcode')}
            banknameField="bankname"
            ibanField="iban"
            branchField="branch"
            bicField="bic"
            cbkeyField="bkey"
            bankField="bname"
            cbnumField="bnum"
            disabled
            currcode={form?.getFieldValue('currcode')}
          />
        </Row>
        <Divider orientation="left">
          {' '}
          <Title comcode="New Information" level={5} />
        </Divider>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item shouldUpdate={() => true} noStyle>
              {({ getFieldValue }) => {
                return (
                  <FormInput name="tpbkidin" comcode="currentBkname">
                    <BankAccountListSelect
                      params={{ tpid: form?.getFieldValue('tpid') }}
                      onSelected={(e) =>
                        form?.setFieldsValue({
                          currcountcode: e?.countcode,
                          ctbankname: e?.bkcodename,
                          ctbranchname: e?.bkbranchcode,
                          ctcbkey: e?.bkaccountkey,
                          ctiban: e?.tpiban,
                          ctbic: e?.tpbic,
                          ctcbname: e?.bkcode,
                          ctcbnum: e?.bkaccountnum,
                          feestype: '',
                          feesTaxrate: 0,
                          feesTaxcode: '',
                          feescategory: '',
                          feesFormula: '' as any,
                          feesAmount: 0,
                        })
                      }
                    />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <FormInput col xs={5} name="currcode">
            <ParListSelect parcode="CURRENCY" disabled />
          </FormInput>
          <Bank
            countcode={form?.getFieldValue('currcountcode')}
            currcode={form?.getFieldValue('currcode')}
            banknameField="ctbankname"
            ibanField="ctiban"
            bicField="ctbic"
            branchField="ctbranchname"
            cbkeyField="ctcbkey"
            bankField="ctcbname"
            cbnumField="ctcbnum"
            disabled
          />
        </Row>

        <Divider orientation="left">
          <Title comcode="fees" level={5} />
        </Divider>

        <Row gutter={16}>
          <FormInput col xs={8} name="feesFormula">
            <PricingListFilteredSelect
              allowClear
              disabled={state.isModSelected}
              params={{
                offerid: offerid ?? 0,
                ctetype: 'MODFEES', // Modifictaion fees
                prcode: contract?.prcode ?? '',
                entity: '',
                entityid: 0,
                tpid: contract?.tpidclient ?? 0,
              }}
              onChange={(e) => {
                calculateFees(e);
              }}
              onClear={() => {
                form?.setFieldValue('feesAmount', 0);
              }}
            />
          </FormInput>
          <FormInput col xs={8} name="feesAmount" shouldUpdate>
            <InputCurrency
              defaultValue={0}
              disabled={
                state.isModSelected ||
                form?.getFieldValue('feesFormula') === undefined ||
                form?.getFieldValue('feesFormula') === 0
              }
              currcode={form?.getFieldValue('currcode')}
            />
          </FormInput>
          {/* <FormInput col xs={12} name="feesTax">
          <Input />
        </FormInput> */}

          <FormInput col xs={12} name="feesTaxcode">
            <Input hidden />
          </FormInput>

          <FormInput col xs={12} name="feesTaxrate">
            <Input hidden />
          </FormInput>
          <FormInput col xs={12} name="feestype">
            <Input hidden />
          </FormInput>
          <FormInput col xs={12} name="feescategory">
            <Input hidden />
          </FormInput>
        </Row>
      </Spin>
    </DF.Provider>
  );
};

export default TabContractChangeBK;
